module.exports = __webpack_public_path__ + "static/00031.8088d1ba.jpg";